// eslint-disable-next-line no-unused-vars
var PokeTranslator = {
    "Bulbasaur": "001_000",
    "Ivysaur": "002_000",
    "Venusaur": "003_000",
    "Venusaur-Mega": "003_000",
    "Venusaur-Gmax": "003_000",
    "Charmander": "004_000",
    "Charmeleon": "005_000",
    "Charizard": "006_000",
    "Charizard-Mega-X": "006_000",
    "Charizard-Mega-Y": "006_000",
    "Charizard-Gmax": "006_000",
    "Squirtle": "007_000",
    "Wartortle": "008_000",
    "Blastoise": "009_000",
    "Blastoise-Mega": "009_000",
    "Blastoise-Gmax": "009_000",
    "Caterpie": "010_000",
    "Metapod": "011_000",
    "Butterfree": "012_000",
    "Butterfree-Gmax": "012_000",
    "Weedle": "013_000",
    "Kakuna": "014_000",
    "Beedrill": "015_000",
    "Beedrill-Mega": "015_000",
    "Pidgey": "016_000",
    "Pidgeotto": "017_000",
    "Pidgeot": "018_000",
    "Pidgeot-Mega": "018_000",
    "Rattata": "019_000",
    "Rattata-Alola": "019_001",
    "Raticate": "020_000",
    "Raticate-Alola": "020_001",
    "Raticate-Alola-Totem": "020_001",
    "Spearow": "021_000",
    "Fearow": "022_000",
    "Ekans": "023_000",
    "Arbok": "024_000",
    "Pikachu": "025_000",
    "Pikachu-Cosplay": "025_000",
    "Pikachu-Rock-Star": "025_000",
    "Pikachu-Belle": "025_000",
    "Pikachu-Pop-Star": "025_000",
    "Pikachu-PhD": "025_000",
    "Pikachu-Libre": "025_000",
    "Pikachu-Original": "025_000",
    "Pikachu-Hoenn": "025_000",
    "Pikachu-Sinnoh": "025_000",
    "Pikachu-Unova": "025_000",
    "Pikachu-Kalos": "025_000",
    "Pikachu-Alola": "025_000",
    "Pikachu-Partner": "025_000",
    "Pikachu-Starter": "025_000",
    "Pikachu-Gmax": "025_000",
    "Pikachu-World": "025_000",
    "Raichu": "026_000",
    "Raichu-Alola": "026_001",
    "Sandshrew": "027_000",
    "Sandshrew-Alola": "027_001",
    "Sandslash": "028_000",
    "Sandslash-Alola": "028_001",
    "Nidoran-F": "029_000",
    "Nidorina": "030_000",
    "Nidoqueen": "031_000",
    "Nidoran-M": "032_000",
    "Nidorino": "033_000",
    "Nidoking": "034_000",
    "Clefairy": "035_000",
    "Clefable": "036_000",
    "Vulpix": "037_000",
    "Vulpix-Alola": "037_001",
    "Ninetales": "038_000",
    "Ninetales-Alola": "038_001",
    "Jigglypuff": "039_000",
    "Wigglytuff": "040_000",
    "Zubat": "041_000",
    "Golbat": "042_000",
    "Oddish": "043_000",
    "Gloom": "044_000",
    "Vileplume": "045_000",
    "Paras": "046_000",
    "Parasect": "047_000",
    "Venonat": "048_000",
    "Venomoth": "049_000",
    "Diglett": "050_000",
    "Diglett-Alola": "050_001",
    "Dugtrio": "051_000",
    "Dugtrio-Alola": "051_001",
    "Meowth": "052_000",
    "Meowth-Alola": "052_001",
    "Meowth-Galar": "052_002",
    "Meowth-Gmax": "052_000",
    "Persian": "053_000",
    "Persian-Alola": "053_001",
    "Psyduck": "054_000",
    "Golduck": "055_000",
    "Mankey": "056_000",
    "Primeape": "057_000",
    "Growlithe": "058_000",
    "Growlithe-Hisui": "058_001",
    "Arcanine": "059_000",
    "Arcanine-Hisui": "059_001",
    "Poliwag": "060_000",
    "Poliwhirl": "061_000",
    "Poliwrath": "062_000",
    "Abra": "063_000",
    "Kadabra": "064_000",
    "Alakazam": "065_000",
    "Alakazam-Mega": "065_000",
    "Machop": "066_000",
    "Machoke": "067_000",
    "Machamp": "068_000",
    "Machamp-Gmax": "068_000",
    "Bellsprout": "069_000",
    "Weepinbell": "070_000",
    "Victreebel": "071_000",
    "Tentacool": "072_000",
    "Tentacruel": "073_000",
    "Geodude": "074_000",
    "Geodude-Alola": "074_001",
    "Graveler": "075_000",
    "Graveler-Alola": "075_001",
    "Golem": "076_000",
    "Golem-Alola": "076_001",
    "Ponyta": "077_000",
    "Ponyta-Galar": "077_001",
    "Rapidash": "078_000",
    "Rapidash-Galar": "078_001",
    "Slowpoke": "079_000",
    "Slowpoke-Galar": "079_001",
    "Slowbro": "080_000",
    "Slowbro-Mega": "080_000",
    "Slowbro-Galar": "080_002",
    "Magnemite": "081_000",
    "Magneton": "082_000",
    "Farfetch\\u2019d": "083_000",
    "Farfetch\\u2019d-Galar": "083_001",
    "Doduo": "084_000",
    "Dodrio": "085_000",
    "Seel": "086_000",
    "Dewgong": "087_000",
    "Grimer": "088_000",
    "Grimer-Alola": "088_001",
    "Muk": "089_000",
    "Muk-Alola": "089_001",
    "Shellder": "090_000",
    "Cloyster": "091_000",
    "Gastly": "092_000",
    "Haunter": "093_000",
    "Gengar": "094_000",
    "Gengar-Mega": "094_000",
    "Gengar-Gmax": "094_000",
    "Onix": "095_000",
    "Drowzee": "096_000",
    "Hypno": "097_000",
    "Krabby": "098_000",
    "Kingler": "099_000",
    "Kingler-Gmax": "099_000",
    "Voltorb": "100_000",
    "Voltorb-Hisui": "100_001",
    "Electrode": "101_000",
    "Electrode-Hisui": "101_001",
    "Exeggcute": "102_000",
    "Exeggutor": "103_000",
    "Exeggutor-Alola": "103_001",
    "Cubone": "104_000",
    "Marowak": "105_000",
    "Marowak-Alola": "105_001",
    "Marowak-Alola-Totem": "105_001",
    "Hitmonlee": "106_000",
    "Hitmonchan": "107_000",
    "Lickitung": "108_000",
    "Koffing": "109_000",
    "Weezing": "110_000",
    "Weezing-Galar": "110_001",
    "Rhyhorn": "111_000",
    "Rhydon": "112_000",
    "Chansey": "113_000",
    "Tangela": "114_000",
    "Kangaskhan": "115_000",
    "Kangaskhan-Mega": "115_000",
    "Horsea": "116_000",
    "Seadra": "117_000",
    "Goldeen": "118_000",
    "Seaking": "119_000",
    "Staryu": "120_000",
    "Starmie": "121_000",
    "Mr. Mime": "122_000",
    "Mr. Mime-Galar": "122_001",
    "Scyther": "123_000",
    "Jynx": "124_000",
    "Electabuzz": "125_000",
    "Magmar": "126_000",
    "Pinsir": "127_000",
    "Pinsir-Mega": "127_000",
    "Tauros": "128_000",
    "Tauros-Paldea-Combat": "128_001_1",
    "Tauros-Paldea-Blaze": "128_002_1",
    "Tauros-Paldea-Aqua": "128_003_1",
    "Magikarp": "129_000",
    "Gyarados": "130_000",
    "Gyarados-Mega": "130_000",
    "Lapras": "131_000",
    "Lapras-Gmax": "131_000",
    "Ditto": "132_000",
    "Eevee": "133_000",
    "Eevee-Starter": "133_000",
    "Eevee-Gmax": "133_000",
    "Vaporeon": "134_000",
    "Jolteon": "135_000",
    "Flareon": "136_000",
    "Porygon": "137_000",
    "Omanyte": "138_000",
    "Omastar": "139_000",
    "Kabuto": "140_000",
    "Kabutops": "141_000",
    "Aerodactyl": "142_000",
    "Aerodactyl-Mega": "142_000",
    "Snorlax": "143_000",
    "Snorlax-Gmax": "143_000",
    "Articuno": "144_000",
    "Articuno-Galar": "144_001",
    "Zapdos": "145_000",
    "Zapdos-Galar": "145_001",
    "Moltres": "146_000",
    "Moltres-Galar": "146_001",
    "Dratini": "147_000",
    "Dragonair": "148_000",
    "Dragonite": "149_000",
    "Mewtwo": "150_000",
    "Mewtwo-Mega-X": "150_000",
    "Mewtwo-Mega-Y": "150_000",
    "Mew": "151_000",
    "Chikorita": "152_000",
    "Bayleef": "153_000",
    "Meganium": "154_000",
    "Cyndaquil": "155_000",
    "Quilava": "156_000",
    "Typhlosion": "157_000",
    "Typhlosion-Hisui": "157_001",
    "Totodile": "158_000",
    "Croconaw": "159_000",
    "Feraligatr": "160_000",
    "Sentret": "161_000",
    "Furret": "162_000",
    "Hoothoot": "163_000",
    "Noctowl": "164_000",
    "Ledyba": "165_000",
    "Ledian": "166_000",
    "Spinarak": "167_000",
    "Ariados": "168_000",
    "Crobat": "169_000",
    "Chinchou": "170_000",
    "Lanturn": "171_000",
    "Pichu": "172_000",
    "Pichu-Spiky-eared": "172_000",
    "Cleffa": "173_000",
    "Igglybuff": "174_000",
    "Togepi": "175_000",
    "Togetic": "176_000",
    "Natu": "177_000",
    "Xatu": "178_000",
    "Mareep": "179_000",
    "Flaaffy": "180_000",
    "Ampharos": "181_000",
    "Ampharos-Mega": "181_000",
    "Bellossom": "182_000",
    "Marill": "183_000",
    "Azumarill": "184_000",
    "Sudowoodo": "185_000",
    "Politoed": "186_000",
    "Hoppip": "187_000",
    "Skiploom": "188_000",
    "Jumpluff": "189_000",
    "Aipom": "190_000",
    "Sunkern": "191_000",
    "Sunflora": "192_000",
    "Yanma": "193_000",
    "Wooper": "194_000",
    "Wooper-Paldea": "194_001",
    "Quagsire": "195_000",
    "Espeon": "196_000",
    "Umbreon": "197_000",
    "Murkrow": "198_000",
    "Slowking": "199_000",
    "Slowking-Galar": "199_001",
    "Misdreavus": "200_000",
    "Unown": "201_000",
    "Wobbuffet": "202_000",
    "Girafarig": "203_000",
    "Pineco": "204_000",
    "Forretress": "205_000",
    "Dunsparce": "206_000",
    "Gligar": "207_000",
    "Steelix": "208_000",
    "Steelix-Mega": "208_000",
    "Snubbull": "209_000",
    "Granbull": "210_000",
    "Qwilfish": "211_000",
    "Qwilfish-Hisui": "211_001",
    "Scizor": "212_000",
    "Scizor-Mega": "212_000",
    "Shuckle": "213_000",
    "Heracross": "214_000",
    "Heracross-Mega": "214_000",
    "Sneasel": "215_000",
    "Sneasel-Hisui": "215_001",
    "Teddiursa": "216_000",
    "Ursaring": "217_000",
    "Slugma": "218_000",
    "Magcargo": "219_000",
    "Swinub": "220_000",
    "Piloswine": "221_000",
    "Corsola": "222_000",
    "Corsola-Galar": "222_001",
    "Remoraid": "223_000",
    "Octillery": "224_000",
    "Delibird": "225_000",
    "Mantine": "226_000",
    "Skarmory": "227_000",
    "Houndour": "228_000",
    "Houndoom": "229_000",
    "Houndoom-Mega": "229_000",
    "Kingdra": "230_000",
    "Phanpy": "231_000",
    "Donphan": "232_000",
    "Porygon2": "233_000",
    "Stantler": "234_000",
    "Smeargle": "235_000",
    "Tyrogue": "236_000",
    "Hitmontop": "237_000",
    "Smoochum": "238_000",
    "Elekid": "239_000",
    "Magby": "240_000",
    "Miltank": "241_000",
    "Blissey": "242_000",
    "Raikou": "243_000",
    "Entei": "244_000",
    "Suicune": "245_000",
    "Larvitar": "246_000",
    "Pupitar": "247_000",
    "Tyranitar": "248_000",
    "Tyranitar-Mega": "248_000",
    "Lugia": "249_000",
    "Ho-Oh": "250_000",
    "Celebi": "251_000",
    "Treecko": "252_000",
    "Grovyle": "253_000",
    "Sceptile": "254_000",
    "Sceptile-Mega": "254_000",
    "Torchic": "255_000",
    "Combusken": "256_000",
    "Blaziken": "257_000",
    "Blaziken-Mega": "257_000",
    "Mudkip": "258_000",
    "Marshtomp": "259_000",
    "Swampert": "260_000",
    "Swampert-Mega": "260_000",
    "Poochyena": "261_000",
    "Mightyena": "262_000",
    "Zigzagoon": "263_000",
    "Zigzagoon-Galar": "263_001",
    "Linoone": "264_000",
    "Linoone-Galar": "264_001",
    "Wurmple": "265_000",
    "Silcoon": "266_000",
    "Beautifly": "267_000",
    "Cascoon": "268_000",
    "Dustox": "269_000",
    "Lotad": "270_000",
    "Lombre": "271_000",
    "Ludicolo": "272_000",
    "Seedot": "273_000",
    "Nuzleaf": "274_000",
    "Shiftry": "275_000",
    "Taillow": "276_000",
    "Swellow": "277_000",
    "Wingull": "278_000",
    "Pelipper": "279_000",
    "Ralts": "280_000",
    "Kirlia": "281_000",
    "Gardevoir": "282_000",
    "Gardevoir-Mega": "282_000",
    "Surskit": "283_000",
    "Masquerain": "284_000",
    "Shroomish": "285_000",
    "Breloom": "286_000",
    "Slakoth": "287_000",
    "Vigoroth": "288_000",
    "Slaking": "289_000",
    "Nincada": "290_000",
    "Ninjask": "291_000",
    "Shedinja": "292_000",
    "Whismur": "293_000",
    "Loudred": "294_000",
    "Exploud": "295_000",
    "Makuhita": "296_000",
    "Hariyama": "297_000",
    "Azurill": "298_000",
    "Nosepass": "299_000",
    "Skitty": "300_000",
    "Delcatty": "301_000",
    "Sableye": "302_000",
    "Sableye-Mega": "302_000",
    "Mawile": "303_000",
    "Mawile-Mega": "303_000",
    "Aron": "304_000",
    "Lairon": "305_000",
    "Aggron": "306_000",
    "Aggron-Mega": "306_000",
    "Meditite": "307_000",
    "Medicham": "308_000",
    "Medicham-Mega": "308_000",
    "Electrike": "309_000",
    "Manectric": "310_000",
    "Manectric-Mega": "310_000",
    "Plusle": "311_000",
    "Minun": "312_000",
    "Volbeat": "313_000",
    "Illumise": "314_000",
    "Roselia": "315_000",
    "Gulpin": "316_000",
    "Swalot": "317_000",
    "Carvanha": "318_000",
    "Sharpedo": "319_000",
    "Sharpedo-Mega": "319_000",
    "Wailmer": "320_000",
    "Wailord": "321_000",
    "Numel": "322_000",
    "Camerupt": "323_000",
    "Camerupt-Mega": "323_000",
    "Torkoal": "324_000",
    "Spoink": "325_000",
    "Grumpig": "326_000",
    "Spinda": "327_000",
    "Trapinch": "328_000",
    "Vibrava": "329_000",
    "Flygon": "330_000",
    "Cacnea": "331_000",
    "Cacturne": "332_000",
    "Swablu": "333_000",
    "Altaria": "334_000",
    "Altaria-Mega": "334_000",
    "Zangoose": "335_000",
    "Seviper": "336_000",
    "Lunatone": "337_000",
    "Solrock": "338_000",
    "Barboach": "339_000",
    "Whiscash": "340_000",
    "Corphish": "341_000",
    "Crawdaunt": "342_000",
    "Baltoy": "343_000",
    "Claydol": "344_000",
    "Lileep": "345_000",
    "Cradily": "346_000",
    "Anorith": "347_000",
    "Armaldo": "348_000",
    "Feebas": "349_000",
    "Milotic": "350_000",
    "Castform": "351_000",
    "Castform-Sunny": "351_000",
    "Castform-Rainy": "351_000",
    "Castform-Snowy": "351_000",
    "Kecleon": "352_000",
    "Shuppet": "353_000",
    "Banette": "354_000",
    "Banette-Mega": "354_000",
    "Duskull": "355_000",
    "Dusclops": "356_000",
    "Tropius": "357_000",
    "Chimecho": "358_000",
    "Absol": "359_000",
    "Absol-Mega": "359_000",
    "Wynaut": "360_000",
    "Snorunt": "361_000",
    "Glalie": "362_000",
    "Glalie-Mega": "362_000",
    "Spheal": "363_000",
    "Sealeo": "364_000",
    "Walrein": "365_000",
    "Clamperl": "366_000",
    "Huntail": "367_000",
    "Gorebyss": "368_000",
    "Relicanth": "369_000",
    "Luvdisc": "370_000",
    "Bagon": "371_000",
    "Shelgon": "372_000",
    "Salamence": "373_000",
    "Salamence-Mega": "373_000",
    "Beldum": "374_000",
    "Metang": "375_000",
    "Metagross": "376_000",
    "Metagross-Mega": "376_000",
    "Regirock": "377_000",
    "Regice": "378_000",
    "Registeel": "379_000",
    "Latias": "380_000",
    "Latias-Mega": "380_000",
    "Latios": "381_000",
    "Latios-Mega": "381_000",
    "Kyogre": "382_000",
    "Kyogre-Primal": "382_000",
    "Groudon": "383_000",
    "Groudon-Primal": "383_000",
    "Rayquaza": "384_000",
    "Rayquaza-Mega": "384_000",
    "Jirachi": "385_000",
    "Deoxys": "386_000",
    "Deoxys-Attack": "386_001",
    "Deoxys-Defense": "386_002",
    "Deoxys-Speed": "386_003",
    "Turtwig": "387_000",
    "Grotle": "388_000",
    "Torterra": "389_000",
    "Chimchar": "390_000",
    "Monferno": "391_000",
    "Infernape": "392_000",
    "Piplup": "393_000",
    "Prinplup": "394_000",
    "Empoleon": "395_000",
    "Starly": "396_000",
    "Staravia": "397_000",
    "Staraptor": "398_000",
    "Bidoof": "399_000",
    "Bibarel": "400_000",
    "Kricketot": "401_000",
    "Kricketune": "402_000",
    "Shinx": "403_000",
    "Luxio": "404_000",
    "Luxray": "405_000",
    "Budew": "406_000",
    "Roserade": "407_000",
    "Cranidos": "408_000",
    "Rampardos": "409_000",
    "Shieldon": "410_000",
    "Bastiodon": "411_000",
    "Burmy": "412_000",
    "Wormadam": "413_000",
    "Wormadam-Sandy": "413_000",
    "Wormadam-Trash": "413_000",
    "Mothim": "414_000",
    "Combee": "415_000",
    "Vespiquen": "416_000",
    "Pachirisu": "417_000",
    "Buizel": "418_000",
    "Floatzel": "419_000",
    "Cherubi": "420_000",
    "Cherrim": "421_000",
    "Cherrim-Sunshine": "421_000",
    "Shellos": "422_000",
    "Gastrodon": "423_000",
    "Ambipom": "424_000",
    "Drifloon": "425_000",
    "Drifblim": "426_000",
    "Buneary": "427_000",
    "Lopunny": "428_000",
    "Lopunny-Mega": "428_000",
    "Mismagius": "429_000",
    "Honchkrow": "430_000",
    "Glameow": "431_000",
    "Purugly": "432_000",
    "Chingling": "433_000",
    "Stunky": "434_000",
    "Skuntank": "435_000",
    "Bronzor": "436_000",
    "Bronzong": "437_000",
    "Bonsly": "438_000",
    "Mime Jr.": "439_000",
    "Happiny": "440_000",
    "Chatot": "441_000",
    "Spiritomb": "442_000",
    "Gible": "443_000",
    "Gabite": "444_000",
    "Garchomp": "445_000",
    "Garchomp-Mega": "445_000",
    "Munchlax": "446_000",
    "Riolu": "447_000",
    "Lucario": "448_000",
    "Lucario-Mega": "448_000",
    "Hippopotas": "449_000",
    "Hippowdon": "450_000",
    "Skorupi": "451_000",
    "Drapion": "452_000",
    "Croagunk": "453_000",
    "Toxicroak": "454_000",
    "Carnivine": "455_000",
    "Finneon": "456_000",
    "Lumineon": "457_000",
    "Mantyke": "458_000",
    "Snover": "459_000",
    "Abomasnow": "460_000",
    "Abomasnow-Mega": "460_000",
    "Weavile": "461_000",
    "Magnezone": "462_000",
    "Lickilicky": "463_000",
    "Rhyperior": "464_000",
    "Tangrowth": "465_000",
    "Electivire": "466_000",
    "Magmortar": "467_000",
    "Togekiss": "468_000",
    "Yanmega": "469_000",
    "Leafeon": "470_000",
    "Glaceon": "471_000",
    "Gliscor": "472_000",
    "Mamoswine": "473_000",
    "Porygon-Z": "474_000",
    "Gallade": "475_000",
    "Gallade-Mega": "475_000",
    "Probopass": "476_000",
    "Dusknoir": "477_000",
    "Froslass": "478_000",
    "Rotom": "479_000",
    "Rotom-Heat": "479_001",
    "Rotom-Wash": "479_002",
    "Rotom-Frost": "479_003",
    "Rotom-Fan": "479_004",
    "Rotom-Mow": "479_005",
    "Uxie": "480_000",
    "Mesprit": "481_000",
    "Azelf": "482_000",
    "Dialga": "483_000",
    "Dialga-Origin": "483_001",
    "Palkia": "484_000",
    "Palkia-Origin": "484_001",
    "Heatran": "485_000",
    "Regigigas": "486_000",
    "Giratina": "487_000",
    "Giratina-Origin": "487_001",
    "Cresselia": "488_000",
    "Phione": "489_000",
    "Manaphy": "490_000",
    "Darkrai": "491_000",
    "Shaymin": "492_000",
    "Shaymin-Sky": "492_001",
    "Arceus": "493_000",
    "Arceus-Bug": "493_000",
    "Arceus-Dark": "493_000",
    "Arceus-Dragon": "493_000",
    "Arceus-Electric": "493_000",
    "Arceus-Fairy": "493_000",
    "Arceus-Fighting": "493_000",
    "Arceus-Fire": "493_000",
    "Arceus-Flying": "493_000",
    "Arceus-Ghost": "493_000",
    "Arceus-Grass": "493_000",
    "Arceus-Ground": "493_000",
    "Arceus-Ice": "493_000",
    "Arceus-Poison": "493_000",
    "Arceus-Psychic": "493_000",
    "Arceus-Rock": "493_000",
    "Arceus-Steel": "493_000",
    "Arceus-Water": "493_000",
    "Victini": "494_000",
    "Snivy": "495_000",
    "Servine": "496_000",
    "Serperior": "497_000",
    "Tepig": "498_000",
    "Pignite": "499_000",
    "Emboar": "500_000",
    "Oshawott": "501_000",
    "Dewott": "502_000",
    "Samurott": "503_000",
    "Samurott-Hisui": "503_001",
    "Patrat": "504_000",
    "Watchog": "505_000",
    "Lillipup": "506_000",
    "Herdier": "507_000",
    "Stoutland": "508_000",
    "Purrloin": "509_000",
    "Liepard": "510_000",
    "Pansage": "511_000",
    "Simisage": "512_000",
    "Pansear": "513_000",
    "Simisear": "514_000",
    "Panpour": "515_000",
    "Simipour": "516_000",
    "Munna": "517_000",
    "Musharna": "518_000",
    "Pidove": "519_000",
    "Tranquill": "520_000",
    "Unfezant": "521_000",
    "Blitzle": "522_000",
    "Zebstrika": "523_000",
    "Roggenrola": "524_000",
    "Boldore": "525_000",
    "Gigalith": "526_000",
    "Woobat": "527_000",
    "Swoobat": "528_000",
    "Drilbur": "529_000",
    "Excadrill": "530_000",
    "Audino": "531_000",
    "Audino-Mega": "531_000",
    "Timburr": "532_000",
    "Gurdurr": "533_000",
    "Conkeldurr": "534_000",
    "Tympole": "535_000",
    "Palpitoad": "536_000",
    "Seismitoad": "537_000",
    "Throh": "538_000",
    "Sawk": "539_000",
    "Sewaddle": "540_000",
    "Swadloon": "541_000",
    "Leavanny": "542_000",
    "Venipede": "543_000",
    "Whirlipede": "544_000",
    "Scolipede": "545_000",
    "Cottonee": "546_000",
    "Whimsicott": "547_000",
    "Petilil": "548_000",
    "Lilligant": "549_000",
    "Lilligant-Hisui": "549_001",
    "Basculin": "550_000",
    "Basculin-Blue-Striped": "550_001",
    "Basculin-White-Striped": "550_002",
    "Sandile": "551_000",
    "Krokorok": "552_000",
    "Krookodile": "553_000",
    "Darumaka": "554_000",
    "Darumaka-Galar": "554_001",
    "Darmanitan": "555_000",
    "Darmanitan-Zen": "555_000",
    "Darmanitan-Galar": "555_002",
    "Darmanitan-Galar-Zen": "555_002",
    "Maractus": "556_000",
    "Dwebble": "557_000",
    "Crustle": "558_000",
    "Scraggy": "559_000",
    "Scrafty": "560_000",
    "Sigilyph": "561_000",
    "Yamask": "562_000",
    "Yamask-Galar": "562_001",
    "Cofagrigus": "563_000",
    "Tirtouga": "564_000",
    "Carracosta": "565_000",
    "Archen": "566_000",
    "Archeops": "567_000",
    "Trubbish": "568_000",
    "Garbodor": "569_000",
    "Garbodor-Gmax": "569_000",
    "Zorua": "570_000",
    "Zorua-Hisui": "570_001",
    "Zoroark": "571_000",
    "Zoroark-Hisui": "571_001",
    "Minccino": "572_000",
    "Cinccino": "573_000",
    "Gothita": "574_000",
    "Gothorita": "575_000",
    "Gothitelle": "576_000",
    "Solosis": "577_000",
    "Duosion": "578_000",
    "Reuniclus": "579_000",
    "Ducklett": "580_000",
    "Swanna": "581_000",
    "Vanillite": "582_000",
    "Vanillish": "583_000",
    "Vanilluxe": "584_000",
    "Deerling": "585_000",
    "Sawsbuck": "586_000",
    "Emolga": "587_000",
    "Karrablast": "588_000",
    "Escavalier": "589_000",
    "Foongus": "590_000",
    "Amoonguss": "591_000",
    "Frillish": "592_000",
    "Jellicent": "593_000",
    "Alomomola": "594_000",
    "Joltik": "595_000",
    "Galvantula": "596_000",
    "Ferroseed": "597_000",
    "Ferrothorn": "598_000",
    "Klink": "599_000",
    "Klang": "600_000",
    "Klinklang": "601_000",
    "Tynamo": "602_000",
    "Eelektrik": "603_000",
    "Eelektross": "604_000",
    "Elgyem": "605_000",
    "Beheeyem": "606_000",
    "Litwick": "607_000",
    "Lampent": "608_000",
    "Chandelure": "609_000",
    "Axew": "610_000",
    "Fraxure": "611_000",
    "Haxorus": "612_000",
    "Cubchoo": "613_000",
    "Beartic": "614_000",
    "Cryogonal": "615_000",
    "Shelmet": "616_000",
    "Accelgor": "617_000",
    "Stunfisk": "618_000",
    "Stunfisk-Galar": "618_001",
    "Mienfoo": "619_000",
    "Mienshao": "620_000",
    "Druddigon": "621_000",
    "Golett": "622_000",
    "Golurk": "623_000",
    "Pawniard": "624_000",
    "Bisharp": "625_000",
    "Bouffalant": "626_000",
    "Rufflet": "627_000",
    "Braviary": "628_000",
    "Braviary-Hisui": "628_001",
    "Vullaby": "629_000",
    "Mandibuzz": "630_000",
    "Heatmor": "631_000",
    "Durant": "632_000",
    "Deino": "633_000",
    "Zweilous": "634_000",
    "Hydreigon": "635_000",
    "Larvesta": "636_000",
    "Volcarona": "637_000",
    "Cobalion": "638_000",
    "Terrakion": "639_000",
    "Virizion": "640_000",
    "Tornadus": "641_000",
    "Tornadus-Therian": "641_001",
    "Thundurus": "642_000",
    "Thundurus-Therian": "642_001",
    "Reshiram": "643_000",
    "Zekrom": "644_000",
    "Landorus": "645_000",
    "Landorus-Therian": "645_001",
    "Kyurem": "646_000",
    "Kyurem-Black": "646_002",
    "Kyurem-White": "646_001",
    "Keldeo": "647_000",
    "Keldeo-Resolute": "647_001",
    "Meloetta": "648_000",
    "Meloetta-Pirouette": "648_001",
    "Genesect": "649_000",
    "Genesect-Douse": "649_000",
    "Genesect-Shock": "649_000",
    "Genesect-Burn": "649_000",
    "Genesect-Chill": "649_000",
    "Chespin": "650_000",
    "Quilladin": "651_000",
    "Chesnaught": "652_000",
    "Fennekin": "653_000",
    "Braixen": "654_000",
    "Delphox": "655_000",
    "Froakie": "656_000",
    "Frogadier": "657_000",
    "Greninja": "658_000",
    "Greninja-Bond": "658_000",
    "Greninja-Ash": "658_002",
    "Bunnelby": "659_000",
    "Diggersby": "660_000",
    "Fletchling": "661_000",
    "Fletchinder": "662_000",
    "Talonflame": "663_000",
    "Scatterbug": "664_000",
    "Spewpa": "665_000",
    "Vivillon": "666_000",
    "Vivillon-Fancy": "666_000",
    "Vivillon-Pokeball": "666_000",
    "Litleo": "667_000",
    "Pyroar": "668_000",
    "Flabe\\u0301be\\u0301": "669_000",
    "Floette": "670_000",
    "Floette-Eternal": "670_005",
    "Florges": "671_000",
    "Skiddo": "672_000",
    "Gogoat": "673_000",
    "Pancham": "674_000",
    "Pangoro": "675_000",
    "Furfrou": "676_000",
    "Espurr": "677_000",
    "Meowstic": "678_000",
    "Meowstic-F": "678_001",
    "Honedge": "679_000",
    "Doublade": "680_000",
    "Aegislash": "681_000",
    "Aegislash-Blade": "681_000",
    "Spritzee": "682_000",
    "Aromatisse": "683_000",
    "Swirlix": "684_000",
    "Slurpuff": "685_000",
    "Inkay": "686_000",
    "Malamar": "687_000",
    "Binacle": "688_000",
    "Barbaracle": "689_000",
    "Skrelp": "690_000",
    "Dragalge": "691_000",
    "Clauncher": "692_000",
    "Clawitzer": "693_000",
    "Helioptile": "694_000",
    "Heliolisk": "695_000",
    "Tyrunt": "696_000",
    "Tyrantrum": "697_000",
    "Amaura": "698_000",
    "Aurorus": "699_000",
    "Sylveon": "700_000",
    "Hawlucha": "701_000",
    "Dedenne": "702_000",
    "Carbink": "703_000",
    "Goomy": "704_000",
    "Sliggoo": "705_000",
    "Sliggoo-Hisui": "705_001",
    "Goodra": "706_000",
    "Goodra-Hisui": "706_001",
    "Klefki": "707_000",
    "Phantump": "708_000",
    "Trevenant": "709_000",
    "Pumpkaboo": "710_000",
    "Pumpkaboo-Small": "710_001",
    "Pumpkaboo-Large": "710_002",
    "Pumpkaboo-Super": "710_003",
    "Gourgeist": "711_000",
    "Gourgeist-Small": "711_001",
    "Gourgeist-Large": "711_002",
    "Gourgeist-Super": "711_003",
    "Bergmite": "712_000",
    "Avalugg": "713_000",
    "Avalugg-Hisui": "713_001",
    "Noibat": "714_000",
    "Noivern": "715_000",
    "Xerneas": "716_000",
    "Xerneas-Neutral": "716_000",
    "Yveltal": "717_000",
    "Zygarde": "718_000",
    "Zygarde-10%": "718_002",
    "Zygarde-Complete": "718_000",
    "Diancie": "719_000",
    "Diancie-Mega": "719_000",
    "Hoopa": "720_000",
    "Hoopa-Unbound": "720_001",
    "Volcanion": "721_000",
    "Rowlet": "722_000",
    "Dartrix": "723_000",
    "Decidueye": "724_000",
    "Decidueye-Hisui": "724_001",
    "Litten": "725_000",
    "Torracat": "726_000",
    "Incineroar": "727_000",
    "Popplio": "728_000",
    "Brionne": "729_000",
    "Primarina": "730_000",
    "Pikipek": "731_000",
    "Trumbeak": "732_000",
    "Toucannon": "733_000",
    "Yungoos": "734_000",
    "Gumshoos": "735_000",
    "Gumshoos-Totem": "735_000",
    "Grubbin": "736_000",
    "Charjabug": "737_000",
    "Vikavolt": "738_000",
    "Vikavolt-Totem": "738_000",
    "Crabrawler": "739_000",
    "Crabominable": "740_000",
    "Oricorio": "741_000",
    "Oricorio-Pom-Pom": "741_001",
    "Oricorio-Pa'u": "741_002",
    "Oricorio-Sensu": "741_003",
    "Cutiefly": "742_000",
    "Ribombee": "743_000",
    "Ribombee-Totem": "743_000",
    "Rockruff": "744_000",
    "Lycanroc": "745_000",
    "Lycanroc-Midnight": "745_001",
    "Lycanroc-Dusk": "745_002",
    "Wishiwashi": "746_000",
    "Wishiwashi-School": "746_000",
    "Mareanie": "747_000",
    "Toxapex": "748_000",
    "Mudbray": "749_000",
    "Mudsdale": "750_000",
    "Dewpider": "751_000",
    "Araquanid": "752_000",
    "Araquanid-Totem": "752_000",
    "Fomantis": "753_000",
    "Lurantis": "754_000",
    "Lurantis-Totem": "754_000",
    "Morelull": "755_000",
    "Shiinotic": "756_000",
    "Salandit": "757_000",
    "Salazzle": "758_000",
    "Salazzle-Totem": "758_000",
    "Stufful": "759_000",
    "Bewear": "760_000",
    "Bounsweet": "761_000",
    "Steenee": "762_000",
    "Tsareena": "763_000",
    "Comfey": "764_000",
    "Oranguru": "765_000",
    "Passimian": "766_000",
    "Wimpod": "767_000",
    "Golisopod": "768_000",
    "Sandygast": "769_000",
    "Palossand": "770_000",
    "Pyukumuku": "771_000",
    "Type: Null": "772_000",
    "Silvally": "773_000",
    "Silvally-Bug": "773_000",
    "Silvally-Dark": "773_000",
    "Silvally-Dragon": "773_000",
    "Silvally-Electric": "773_000",
    "Silvally-Fairy": "773_000",
    "Silvally-Fighting": "773_000",
    "Silvally-Fire": "773_000",
    "Silvally-Flying": "773_000",
    "Silvally-Ghost": "773_000",
    "Silvally-Grass": "773_000",
    "Silvally-Ground": "773_000",
    "Silvally-Ice": "773_000",
    "Silvally-Poison": "773_000",
    "Silvally-Psychic": "773_000",
    "Silvally-Rock": "773_000",
    "Silvally-Steel": "773_000",
    "Silvally-Water": "773_000",
    "Minior": "774_000",
    "Minior-Meteor": "774_000",
    "Komala": "775_000",
    "Turtonator": "776_000",
    "Togedemaru": "777_000",
    "Togedemaru-Totem": "777_000",
    "Mimikyu": "778_000",
    "Mimikyu-Busted": "778_000",
    "Mimikyu-Totem": "778_000",
    "Mimikyu-Busted-Totem": "778_000",
    "Bruxish": "779_000",
    "Drampa": "780_000",
    "Dhelmise": "781_000",
    "Jangmo-o": "782_000",
    "Hakamo-o": "783_000",
    "Kommo-o": "784_000",
    "Kommo-o-Totem": "784_000",
    "Tapu Koko": "785_000",
    "Tapu Lele": "786_000",
    "Tapu Bulu": "787_000",
    "Tapu Fini": "788_000",
    "Cosmog": "789_000",
    "Cosmoem": "790_000",
    "Solgaleo": "791_000",
    "Lunala": "792_000",
    "Nihilego": "793_000",
    "Buzzwole": "794_000",
    "Pheromosa": "795_000",
    "Xurkitree": "796_000",
    "Celesteela": "797_000",
    "Kartana": "798_000",
    "Guzzlord": "799_000",
    "Necrozma": "800_000",
    "Necrozma-Dusk-Mane": "800_001",
    "Necrozma-Dawn-Wings": "800_002",
    "Necrozma-Ultra": "800_000",
    "Magearna": "801_000",
    "Magearna-Original": "801_000",
    "Marshadow": "802_000",
    "Poipole": "803_000",
    "Naganadel": "804_000",
    "Stakataka": "805_000",
    "Blacephalon": "806_000",
    "Zeraora": "807_000",
    "Meltan": "808_000",
    "Melmetal": "809_000",
    "Melmetal-Gmax": "809_000",
    "Grookey": "810_000",
    "Thwackey": "811_000",
    "Rillaboom": "812_000",
    "Rillaboom-Gmax": "812_000",
    "Scorbunny": "813_000",
    "Raboot": "814_000",
    "Cinderace": "815_000",
    "Cinderace-Gmax": "815_000",
    "Sobble": "816_000",
    "Drizzile": "817_000",
    "Inteleon": "818_000",
    "Inteleon-Gmax": "818_000",
    "Skwovet": "819_000",
    "Greedent": "820_000",
    "Rookidee": "821_000",
    "Corvisquire": "822_000",
    "Corviknight": "823_000",
    "Corviknight-Gmax": "823_000",
    "Blipbug": "824_000",
    "Dottler": "825_000",
    "Orbeetle": "826_000",
    "Orbeetle-Gmax": "826_000",
    "Nickit": "827_000",
    "Thievul": "828_000",
    "Gossifleur": "829_000",
    "Eldegoss": "830_000",
    "Wooloo": "831_000",
    "Dubwool": "832_000",
    "Chewtle": "833_000",
    "Drednaw": "834_000",
    "Drednaw-Gmax": "834_000",
    "Yamper": "835_000",
    "Boltund": "836_000",
    "Rolycoly": "837_000",
    "Carkol": "838_000",
    "Coalossal": "839_000",
    "Coalossal-Gmax": "839_000",
    "Applin": "840_000",
    "Flapple": "841_000",
    "Flapple-Gmax": "841_000",
    "Appletun": "842_000",
    "Appletun-Gmax": "842_000",
    "Silicobra": "843_000",
    "Sandaconda": "844_000",
    "Sandaconda-Gmax": "844_000",
    "Cramorant": "845_000",
    "Cramorant-Gulping": "845_000",
    "Cramorant-Gorging": "845_000",
    "Arrokuda": "846_000",
    "Barraskewda": "847_000",
    "Toxel": "848_000",
    "Toxtricity": "849_000",
    "Toxtricity-Low-Key": "849_001",
    "Toxtricity-Gmax": "849_000",
    "Toxtricity-Low-Key-Gmax": "849_001",
    "Sizzlipede": "850_000",
    "Centiskorch": "851_000",
    "Centiskorch-Gmax": "851_000",
    "Clobbopus": "852_000",
    "Grapploct": "853_000",
    "Sinistea": "854_000",
    "Sinistea-Antique": "854_000",
    "Polteageist": "855_000",
    "Polteageist-Antique": "855_000",
    "Hatenna": "856_000",
    "Hattrem": "857_000",
    "Hatterene": "858_000",
    "Hatterene-Gmax": "858_000",
    "Impidimp": "859_000",
    "Morgrem": "860_000",
    "Grimmsnarl": "861_000",
    "Grimmsnarl-Gmax": "861_000",
    "Obstagoon": "862_000",
    "Perrserker": "863_000",
    "Cursola": "864_000",
    "Sirfetch\\u2019d": "865_000",
    "Mr. Rime": "866_000",
    "Runerigus": "867_000",
    "Milcery": "868_000",
    "Alcremie": "869_000",
    "Alcremie-Gmax": "869_000",
    "Falinks": "870_000",
    "Pincurchin": "871_000",
    "Snom": "872_000",
    "Frosmoth": "873_000",
    "Stonjourner": "874_000",
    "Eiscue": "875_000",
    "Eiscue-Noice": "875_000",
    "Indeedee": "876_000",
    "Indeedee-F": "876_001",
    "Morpeko": "877_000",
    "Morpeko-Hangry": "877_000",
    "Cufant": "878_000",
    "Copperajah": "879_000",
    "Copperajah-Gmax": "879_000",
    "Dracozolt": "880_000",
    "Arctozolt": "881_000",
    "Dracovish": "882_000",
    "Arctovish": "883_000",
    "Duraludon": "884_000",
    "Duraludon-Gmax": "884_000",
    "Dreepy": "885_000",
    "Drakloak": "886_000",
    "Dragapult": "887_000",
    "Zacian": "888_000",
    "Zacian-Crowned": "888_000",
    "Zamazenta": "889_000",
    "Zamazenta-Crowned": "889_000",
    "Eternatus": "890_000",
    "Eternatus-Eternamax": "890_000",
    "Kubfu": "891_000",
    "Urshifu": "892_000",
    "Urshifu-Rapid-Strike": "892_001",
    "Urshifu-Gmax": "892_000",
    "Urshifu-Rapid-Strike-Gmax": "892_001",
    "Zarude": "893_000",
    "Zarude-Dada": "893_001",
    "Regieleki": "894_000",
    "Regidrago": "895_000",
    "Glastrier": "896_000",
    "Spectrier": "897_000",
    "Calyrex": "898_000",
    "Calyrex-Ice": "898_001",
    "Calyrex-Shadow": "898_002",
    "Wyrdeer": "899_000",
    "Kleavor": "900_000",
    "Ursaluna": "901_000",
    "Ursaluna-Bloodmoon": "901_001",
    "Basculegion": "902_000",
    "Basculegion-F": "902_001",
    "Sneasler": "903_000",
    "Overqwil": "904_000",
    "Enamorus": "905_000",
    "Enamorus-Therian": "905_001",
    "Sprigatito": "906_000",
    "Floragato": "907_000",
    "Meowscarada": "908_000",
    "Fuecoco": "909_000",
    "Crocalor": "910_000",
    "Skeledirge": "911_000",
    "Quaxly": "912_000",
    "Quaxwell": "913_000",
    "Quaquaval": "914_000",
    "Lechonk": "915_000",
    "Oinkologne": "916_000",
    "Oinkologne-F": "916_001",
    "Tarountula": "917_000",
    "Spidops": "918_000",
    "Nymble": "919_000",
    "Lokix": "920_000",
    "Pawmi": "921_000",
    "Pawmo": "922_000",
    "Pawmot": "923_000",
    "Tandemaus": "924_000",
    "Maushold": "925_000",
    "Maushold-Four": "925_000",
    "Fidough": "926_000",
    "Dachsbun": "927_000",
    "Smoliv": "928_000",
    "Dolliv": "929_000",
    "Arboliva": "930_000",
    "Squawkabilly": "931_000",
    "Squawkabilly-Blue": "931_001",
    "Squawkabilly-Yellow": "931_002",
    "Squawkabilly-White": "931_003",
    "Nacli": "932_000",
    "Naclstack": "933_000",
    "Garganacl": "934_000",
    "Charcadet": "935_000",
    "Armarouge": "936_000",
    "Ceruledge": "937_000",
    "Tadbulb": "938_000",
    "Bellibolt": "939_000",
    "Wattrel": "940_000",
    "Kilowattrel": "941_000",
    "Maschiff": "942_000",
    "Mabosstiff": "943_000",
    "Shroodle": "944_000",
    "Grafaiai": "945_000",
    "Bramblin": "946_000",
    "Brambleghast": "947_000",
    "Toedscool": "948_000",
    "Toedscruel": "949_000",
    "Klawf": "950_000",
    "Capsakid": "951_000",
    "Scovillain": "952_000",
    "Rellor": "953_000",
    "Rabsca": "954_000",
    "Flittle": "955_000",
    "Espathra": "956_000",
    "Tinkatink": "957_000",
    "Tinkatuff": "958_000",
    "Tinkaton": "959_000",
    "Wiglett": "960_000",
    "Wugtrio": "961_000",
    "Bombirdier": "962_000",
    "Finizen": "963_000",
    "Palafin": "964_000",
    "Palafin-Hero": "964_000",
    "Varoom": "965_000",
    "Revavroom": "966_000",
    "Cyclizar": "967_000",
    "Orthworm": "968_000",
    "Glimmet": "969_000",
    "Glimmora": "970_000",
    "Greavard": "971_000",
    "Houndstone": "972_000",
    "Flamigo": "973_000",
    "Cetoddle": "974_000",
    "Cetitan": "975_000",
    "Veluza": "976_000",
    "Dondozo": "977_000",
    "Tatsugiri": "978_000",
    "Tatsugiri-Droopy": "978_001",
    "Tatsugiri-Stretchy": "978_002",
    "Annihilape": "979_000",
    "Clodsire": "980_000",
    "Farigiraf": "981_000",
    "Dudunsparce": "982_000",
    "Dudunsparce-Three-Segment": "982_000",
    "Kingambit": "983_000",
    "Great Tusk": "984_000",
    "Scream Tail": "985_000",
    "Brute Bonnet": "986_000",
    "Flutter Mane": "987_000",
    "Slither Wing": "988_000",
    "Sandy Shocks": "989_000",
    "Iron Treads": "990_000",
    "Iron Bundle": "991_000",
    "Iron Hands": "992_000",
    "Iron Jugulis": "993_000",
    "Iron Moth": "994_000",
    "Iron Thorns": "995_000",
    "Frigibax": "996_000",
    "Arctibax": "997_000",
    "Baxcalibur": "998_000",
    "Gimmighoul": "999_000",
    "Gimmighoul-Roaming": "999_001",
    "Gholdengo": "1000_000",
    "Wo-Chien": "1001_000",
    "Chien-Pao": "1002_000",
    "Ting-Lu": "1003_000",
    "Chi-Yu": "1004_000",
    "Roaring Moon": "1005_000",
    "Iron Valiant": "1006_000",
    "Koraidon": "1007_000",
    "Miraidon": "1008_000",
    "Walking Wake": "1009_000",
    "Iron Leaves": "1010_000",
    "Dipplin": "1011_000",
    "Poltchageist": "1012_000",
    "Poltchageist-Artisan": "1012_000",
    "Sinistcha": "1013_000",
    "Sinistcha-Masterpiece": "1013_000",
    "Okidogi": "1014_000",
    "Munkidori": "1015_000",
    "Fezandipiti": "1016_000",
    "Ogerpon": "1017_000",
    "Ogerpon-Wellspring": "1017_001",
    "Ogerpon-Hearthflame": "1017_002",
    "Ogerpon-Cornerstone": "1017_003",
    "Ogerpon-Teal-Tera": "1017_000",
    "Ogerpon-Wellspring-Tera": "1017_001",
    "Ogerpon-Hearthflame-Tera": "1017_002",
    "Ogerpon-Cornerstone-Tera": "1017_003",
    "Archaludon": "1018_000",
    "Hydrapple": "1019_000",
    "Gouging Fire": "1020_000",
    "Raging Bolt": "1021_000",
    "Iron Boulder": "1022_000",
    "Iron Crown": "1023_000",
    "Terapagos": "1024_000",
    "Terapagos-Terastal": "1024_000",
    "Terapagos-Stellar": "1024_000",
    "Pecharunt": "1025_000",
    "MissingNo.": "000_000"
}
export default PokeTranslator;